// import 'core-js'
import Vue from 'vue';

import BootstrapVue from 'bootstrap-vue';
import VueFlatPickr from 'vue-flatpickr-component';
import { Plugin as vueFragment } from 'vue-fragment';
import VueTheMask from 'vue-the-mask';
import Moment from 'moment';

import Multiselect from 'vue-multiselect';
import VueJsonPretty from 'vue-json-pretty';
import sanitizeHTML from 'sanitize-html';

import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';

import parseDate from './filters/parseDate';

import App from './App';
import router from './router';
import store from './store';
import axiosInstance from './api';
import showSuccessMessage from './utils/show-success-message';

import 'vue-multiselect/dist/vue-multiselect.min.css';
import 'vue-json-pretty/lib/styles.css';
import 'flatpickr/dist/flatpickr.css';
import './styles/index.scss';

import config from './utils/config';

Vue.use(BootstrapVue);
Vue.use(VueFlatPickr);
Vue.use(vueFragment);
Vue.use(VueTheMask);

Vue.component('multiselect', Multiselect);
Vue.component('vue-json-pretty', VueJsonPretty);

Vue.filter('parseDate', parseDate);

Moment.locale('ru');
Vue.prototype.$config = config;
Vue.prototype.$moment = Moment;
Vue.prototype.$http = axiosInstance;
Vue.prototype.$sanitize = sanitizeHTML;
Vue.prototype.$showSuccessMessage = showSuccessMessage;

if (config.SENTRY_DSN) {
  Sentry.init({
    Vue,
    dsn: config.SENTRY_DSN,
    ...(config.SENTRY_TUNNEL ? { tunnel: config.SENTRY_TUNNEL } : {}),
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
    logErrors: true,
  });
}

/* eslint-disable no-new */
const app = new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App),
});

export default app;
